
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipRemoteGeneric as ObiOwnShipRemoteGenericElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-remote-generic.js';
 
 
 

 
 export const ObiOwnShipRemoteGeneric = createComponent({
   react: React,
   tagName: 'obi-own-ship-remote-generic',
   elementClass: ObiOwnShipRemoteGenericElement,
   events: {
     
   }
  });
 
 